import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ICustomShiftFlagAccessor, 'ICustomShiftFlagAccessor');
initMetadataForInterface(IScheduleWarningAccessor, 'IScheduleWarningAccessor');
initMetadataForClass(CustomShiftFlag, 'CustomShiftFlag');
initMetadataForInterface(ICustomShiftFlagMutator, 'ICustomShiftFlagMutator', VOID, VOID, VOID, [1, 2]);
//endregion
function ICustomShiftFlagAccessor() {
}
function IScheduleWarningAccessor() {
}
function CustomShiftFlag(id, name, color) {
  this.f8d_1 = id;
  this.g8d_1 = name;
  this.h8d_1 = color;
}
protoOf(CustomShiftFlag).toString = function () {
  return 'CustomShiftFlag(id=' + this.f8d_1.toString() + ', name=' + this.g8d_1 + ', color=' + this.h8d_1 + ')';
};
protoOf(CustomShiftFlag).hashCode = function () {
  var result = this.f8d_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.g8d_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.h8d_1) | 0;
  return result;
};
protoOf(CustomShiftFlag).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CustomShiftFlag))
    return false;
  var tmp0_other_with_cast = other instanceof CustomShiftFlag ? other : THROW_CCE();
  if (!this.f8d_1.equals(tmp0_other_with_cast.f8d_1))
    return false;
  if (!(this.g8d_1 === tmp0_other_with_cast.g8d_1))
    return false;
  if (!(this.h8d_1 === tmp0_other_with_cast.h8d_1))
    return false;
  return true;
};
function ICustomShiftFlagMutator() {
}
//region block: exports
export {
  ICustomShiftFlagAccessor as ICustomShiftFlagAccessor21oxot5gxdn5a,
  IScheduleWarningAccessor as IScheduleWarningAccessor3mhssfafpp187,
  CustomShiftFlag as CustomShiftFlag3j9rrshyn9z40,
  ICustomShiftFlagMutator as ICustomShiftFlagMutator1702xc1l2rf9w,
};
//endregion

